import { useState } from "react";

function UtilityBillLineUpload(props) {
    const [invalid, setInvalid] = useState([])
    const monthsDict = {
        1: "Jan",
        2: "Feb",
        3: "Mar",
        4: "Apr",
        5: "May",
        6: "Jun",
        7: "Jul",
        8: "Aug",
        9: "Sep",
        10: "Oct",
        11: "Nov",
        12: "Dec"
    }

    const totalList = [
        "basic_monthly",
        "kwh_cost",
        "kva_cost",
        "water_cost",
        "sewage_cost",
        "gas_cost",
        "delivery_charges",
        "other_charges",
        "carbon_charge",
        "municipal_tax",
        "gst_cost",
        "pst_cost",
    ]

    const normalizeId = (id) => `${id}`.replace(/[.\-\s]/g, "");

    const updateValue = (e) => {
        const { name, value } = e.target;
        let tempBill = JSON.parse(JSON.stringify(props.value))
        tempBill = {
            ...tempBill,
            [name]: value.trim()
        }

        // Match with accounts
        if (name === 'utility_bill_account_id') {
            let tempType = props.accounts.filter(a => parseInt(a.id) === parseInt(tempBill.utility_bill_account_id))
            if (tempType.length > 0) {
                tempBill.utility_bill_account_id = tempType[0].id
                tempBill.type = tempType[0].type
            } else {
                tempBill.type = 0
            }
        }

        let mandatory = [
            "utility_bill_account_id",
            "bill_id",
            "bill_month",
            "bill_year",
            "basic_monthly",
            "kwh_consumption",
            "kwh_cost",
            "kva_consumption",
            "kva_cost",
            "water_consumption",
            "water_cost",
            "sewage_consumption",
            "sewage_cost",
            "gas_consumption",
            "gas_cost",
            "delivery_charges",
            "other_charges",
            "carbon_charge",
            "municipal_tax",
            "gst_cost",
            "pst_cost",
        ]
        for (let item of mandatory) {
            if (item in tempBill && tempBill[item] !== null && tempBill[item] !== '') setInvalid(prev => prev.filter(val => val !== item))
            else setInvalid(prev => [...prev, item])
        }

        props.setFiles(prev => {
            let tempArr = JSON.parse(JSON.stringify(prev))
            const fileIdx = tempArr.findIndex(f => f.tempId === props.fileIndex)
            if (fileIdx === -1) tempArr[0] = { bills: [tempBill] }
            else tempArr[fileIdx].bills.splice(props.billIndex, 1, tempBill)
            return tempArr
        })
    }

    return (
        <div className='w-full overflow-x-auto'>
            <div className='min-w-[1200px]'>
                {props.value && <div className='w-full flex flex-nowrap input-border p-4 gap-6'>
                    {props.value.duplicate && <p className="py-2 text-md text-[red] font-bold">Duplicate (skipped)</p>}
                    <div className='w-full'>
                        <div className='w-full mb-4'>
                            <p className={`text-sm mb-1 ${invalid.includes("") ? "text-[red]" : ""}`}>Account</p>
                            <select
                                name="utility_bill_account_id"
                                className='text-sm input-color outline-none w-full hide-input-background'
                                value={props.value.utility_bill_account_id ? props.value.utility_bill_account_id : ""}
                                onChange={updateValue}>
                                <option value="">Unknown</option>
                                {
                                    props.accounts && props.accounts.map((a, ix) => (
                                        <option key={ix + "utilityaccounts"} value={normalizeId(a.id)}>{a.name}</option>
                                    ))
                                }
                            </select>
                        </div>
                        <div className='mb-4'>
                            <p className={`text-sm mb-1 ${invalid.includes("bill_id") ? "text-[red]" : ""}`}>Bill ID</p>
                            <div className='flex flex-nowrap items-center'>
                                <input
                                    placeholder='Bill ID'
                                    className='text-sm input-color outline-none w-full hide-input-background p-1'
                                    type="text"
                                    name="bill_id"
                                    value={props.value.bill_id !== "" ? props.value.bill_id : ""}
                                    onChange={updateValue} />
                            </div>
                        </div>
                    </div>
                    {
                        props.value.site_id &&
                        <div className='w-full'>
                            <div className='w-full mb-4'>
                                <p className={`text-sm mb-1 ${invalid.includes("") ? "text-[red]" : ""}`}>Site ID</p>
                                <select
                                    name="site_id"
                                    className='text-sm input-color outline-none w-full hide-input-background'
                                    value={props.value.site_id ? props.value.site_id : ""}
                                    onChange={updateValue}>
                                    <option value="">Unknown</option>
                                    {
                                        props.accounts && props.accounts.map((a, ix) => (
                                            <option key={ix + "utilityaccounts"} value={normalizeId(a.site_id)}>{a.site_id}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className='w-full mb-4'>
                                <p className={`text-sm mb-1 ${invalid.includes("") ? "text-[red]" : ""}`}>Building</p>
                                <p className='text-sm input-color w-full'>{props.accounts.find(e => normalizeId(e.site_id) === props.value.site_id)?.building}</p>
                            </div>
                        </div>
                    }
                    <div className='w-full'>
                        <div className='w-full min-w-[80px] mb-4'>
                            <p className={`text-sm mb-1 ${invalid.includes("bill_month") ? "text-[red]" : ""}`}>Month</p>
                            <select
                                name="bill_month"
                                className='text-sm input-color outline-none w-full hide-input-background'
                                value={props.value.bill_month ? props.value.bill_month : ""}
                                onChange={updateValue}>
                                <option value="">Month</option>
                                {
                                    Object.keys(monthsDict).map((e, ix) => (
                                        <option key={ix + "billinngmonth"} value={e}>{monthsDict[e]}</option>
                                    ))
                                }
                            </select>
                        </div>
                        <div className='w-full min-w-[80px] mb-4'>
                            <p className={`text-sm mb-1 ${invalid.includes("bill_year") ? "text-[red]" : ""}`}>Year</p>
                            <select
                                name="bill_year"
                                className='text-sm input-color outline-none w-full hide-input-background'
                                value={props.value.bill_year !== "" ? props.value.bill_year : ""}
                                onChange={updateValue}
                            >
                                <option value="">Year</option>
                                {
                                    Array.from({ length: new Date().getFullYear() - 1999 }, (_, i) => {
                                        const year = 2000 + i;
                                        return (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        );
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    {
                        props.type === 0 &&
                        <div className='w-full'>
                            <div className='mb-4'>
                                <p className={`text-sm mb-1 ${invalid.includes("kwh_consumption") ? "text-[red]" : ""}`}>kWh Consumption</p>
                                <div className='flex flex-nowrap items-center'>
                                    <input
                                        placeholder='kWh Consumption'
                                        className='hide-input-background text-sm input-color outline-none w-full p-1'
                                        type="number"
                                        step="0.1"
                                        name="kwh_consumption"
                                        defaultValue={props.value.kwh_consumption !== "" ? props.value.kwh_consumption : ""}
                                        onChange={updateValue} />
                                    <span className='ml-1 text-sm'>kWh</span>
                                </div>
                            </div>
                            <div className='mb-4'>
                                <p className={`text-sm mb-1 ${invalid.includes("kwh_cost") ? "text-[red]" : ""}`}>kWh Cost</p>
                                <div className='flex flex-nowrap items-center'>
                                    <span className='mr-1 text-sm'>$</span>
                                    <input
                                        placeholder='kwh_cost'
                                        className='hide-input-background text-sm input-color outline-none w-full p-1'
                                        type="number"
                                        step="0.1"
                                        name="kwh_cost"
                                        defaultValue={props.value.kwh_cost !== "" ? props.value.kwh_cost : ""}
                                        onChange={updateValue} />
                                </div>
                            </div>
                        </div>
                    }
                    {
                        props.type === 0 &&
                        <div className='w-full'>
                            <div className='mb-4'>
                                <p className={`text-sm mb-1 ${invalid.includes("kva_consumption") ? "text-[red]" : ""}`}>kVA Peak</p>
                                <div className='flex flex-nowrap items-center'>
                                    <input
                                        placeholder='kVA Peak'
                                        className='hide-input-background text-sm input-color outline-none w-full p-1'
                                        type="number"
                                        step="0.1"
                                        name="kva_consumption"
                                        defaultValue={props.value.kva_consumption !== "" ? props.value.kva_consumption : ""}
                                        onChange={updateValue} />
                                    <span className='ml-1 text-sm'>kVA</span>
                                </div>
                            </div>
                            <div className='mb-4'>
                                <p className={`text-sm mb-1 ${invalid.includes("kva_cost") ? "text-[red]" : ""}`}>kVA Cost</p>
                                <div className='flex flex-nowrap items-center'>
                                    <span className='mr-1 text-sm'>$</span>
                                    <input
                                        placeholder='kVA Cost'
                                        className='hide-input-background text-sm input-color outline-none w-full p-1'
                                        type="number"
                                        step="0.1"
                                        name="kva_cost"
                                        defaultValue={props.value.kva_cost !== "" ? props.value.kva_cost : ""}
                                        onChange={updateValue} />
                                </div>
                            </div>
                        </div>
                    }
                    {
                        props.type === 1 &&
                        <div className='w-full'>
                            <div className='mb-4'>
                                <p className={`text-sm mb-1 ${invalid.includes("gas_consumption") ? "text-[red]" : ""}`}>Gas Consumption</p>
                                <div className='flex flex-nowrap items-center'>
                                    <input
                                        placeholder='Gas Consumption'
                                        className='hide-input-background text-sm input-color outline-none w-full p-1'
                                        type="number"
                                        step="0.1"
                                        name="gas_consumption"
                                        defaultValue={props.value.gas_consumption !== "" ? props.value.gas_consumption : ""}
                                        onChange={updateValue} />
                                    <select
                                        name="gas_unit"
                                        className='text-sm input-color outline-none w-1/2 ml-2 hide-input-background'
                                        value={props.value.gas_unit ? props.value.gas_unit : ""}
                                        onChange={updateValue}>
                                        <option value="ft3">ft³</option>
                                        <option value="m3">m³</option>
                                        <option value="l">L</option>
                                        <option value="GJ">GJ</option>
                                    </select>
                                </div>
                            </div>
                            <div className='mb-4'>
                                <p className={`text-sm mb-1 ${invalid.includes("gas_cost") ? "text-[red]" : ""}`}>Gas Cost</p>
                                <div className='flex flex-nowrap items-center'>
                                    <span className='mr-1 text-sm'>$</span>
                                    <input
                                        placeholder='Gas Cost'
                                        className='hide-input-background text-sm input-color outline-none w-full p-1'
                                        type="number"
                                        step="0.1"
                                        name="gas_cost"
                                        defaultValue={props.value.gas_cost !== "" ? props.value.gas_cost : ""}
                                        onChange={updateValue} />
                                </div>
                            </div>
                        </div>
                    }
                    {
                        props.type === 2 &&
                        <div className='w-full'>
                            <div className='mb-4'>
                                <p className={`text-sm mb-1 ${invalid.includes("water_consumption") ? "text-[red]" : ""}`}>Water Consumption</p>
                                <div className='flex flex-nowrap items-center'>
                                    <input
                                        placeholder='Water Consumption'
                                        className='hide-input-background text-sm input-color outline-none w-full p-1'
                                        type="number"
                                        step="0.1"
                                        name="water_consumption"
                                        defaultValue={props.value.water_consumption !== "" ? props.value.water_consumption : ""}
                                        onChange={updateValue} />
                                    <select
                                        name="water_unit"
                                        className='text-sm input-color outline-none w-1/2 ml-2 hide-input-background'
                                        value={props.value.water_unit ? props.value.water_unit : ""}
                                        onChange={updateValue}>
                                        <option value="ft3">ft³</option>
                                        <option value="m3">m³</option>
                                        <option value="l">L</option>
                                    </select>
                                </div>
                            </div>
                            <div className='mb-4'>
                                <p className={`text-sm mb-1 ${invalid.includes("water_cost") ? "text-[red]" : ""}`}>Water Cost</p>
                                <div className='flex flex-nowrap items-center'>
                                    <span className='mr-1 text-sm'>$</span>
                                    <input
                                        placeholder='Water Cost'
                                        className='hide-input-background text-sm input-color outline-none w-full p-1'
                                        type="number"
                                        step="0.1"
                                        name="water_cost"
                                        defaultValue={props.value.water_cost !== "" ? props.value.water_cost : ""}
                                        onChange={updateValue} />
                                </div>
                            </div>
                        </div>
                    }
                    {
                        props.type === 2 &&
                        <div className='w-full'>
                            <div className='mb-4'>
                                <p className={`text-sm mb-1 ${invalid.includes("sewage_consumption") ? "text-[red]" : ""}`}>Sewage Consumption</p>
                                <div className='flex flex-nowrap items-center'>
                                    <input
                                        placeholder='Sewage Consumption'
                                        className='hide-input-background text-sm input-color outline-none w-full p-1'
                                        type="number"
                                        step="0.1"
                                        name="sewage_consumption"
                                        defaultValue={props.value.sewage_consumption !== "" ? props.value.sewage_consumption : ""}
                                        onChange={updateValue} />
                                    <select
                                        name="water_unit"
                                        disabled
                                        className='text-sm input-color outline-none w-1/2 ml-2 hide-input-background'
                                        value={props.value.water_unit ? props.value.water_unit : ""}
                                        onChange={updateValue}>
                                        <option value="ft3">ft³</option>
                                        <option value="m3">m³</option>
                                        <option value="l">L</option>
                                    </select>
                                </div>
                            </div>
                            <div className='mb-4'>
                                <p className={`text-sm mb-1 ${invalid.includes("sewage_cost") ? "text-[red]" : ""}`}>Sewage Cost</p>
                                <div className='flex flex-nowrap items-center'>
                                    <span className='mr-1 text-sm'>$</span>
                                    <input
                                        placeholder='Sewage Cost'
                                        className='hide-input-background text-sm input-color outline-none w-full p-1'
                                        type="number"
                                        step="0.1"
                                        name="sewage_cost"
                                        defaultValue={props.value.sewage_cost !== "" ? props.value.sewage_cost : ""}
                                        onChange={updateValue} />
                                </div>
                            </div>
                        </div>
                    }
                    <div className='w-full'>
                        <div className='mb-4'>
                            <p className={`text-sm mb-1 ${invalid.includes("basic_monthly") ? "text-[red]" : ""}`}>Basic Charge</p>
                            <div className='flex flex-nowrap items-center'>
                                <span className='mr-1 text-sm'>$</span>
                                <input
                                    placeholder='Price'
                                    className='hide-input-background text-sm input-color outline-none w-full p-1'
                                    type="number"
                                    step="0.1"
                                    name="basic_monthly"
                                    defaultValue={props.value.basic_monthly !== "" ? props.value.basic_monthly : ""}
                                    onChange={updateValue} />
                            </div>
                        </div>
                        {[0, 1].includes(props.type) &&
                            <div className='mb-4'>
                                <p className={`text-sm mb-1 ${invalid.includes("carbon_charge") ? "text-[red]" : ""}`}>Carbon Charge</p>
                                <div className='flex flex-nowrap items-center'>
                                    <span className='mr-1 text-sm'>$</span>
                                    <input
                                        placeholder='Carbon Charge'
                                        className='hide-input-background text-sm input-color outline-none w-full p-1'
                                        type="number"
                                        step="0.1"
                                        name="carbon_charge"
                                        defaultValue={props.value.carbon_charge !== "" ? props.value.carbon_charge : ""}
                                        onChange={updateValue} />
                                </div>
                            </div>
                        }
                    </div>
                    <div className='w-full'>
                        <div className='mb-4'>
                            <p className={`text-sm mb-1 ${invalid.includes("delivery_charges") ? "text-[red]" : ""}`}>Delivery Charges</p>
                            <div className='flex flex-nowrap items-center'>
                                <span className='ml-1 text-sm'>$</span>
                                <input
                                    placeholder='Delivery'
                                    className='hide-input-background text-sm input-color outline-none w-full p-1'
                                    type="number"
                                    step="0.1"
                                    name="delivery_charges"
                                    defaultValue={props.value.delivery_charges !== "" ? props.value.delivery_charges : ""}
                                    onChange={updateValue} />
                            </div>
                        </div>
                        <div className='mb-4'>
                            <p className={`text-sm mb-1 ${invalid.includes("other_charges") ? "text-[red]" : ""}`}>Other Charges</p>
                            <div className='flex flex-nowrap items-center'>
                                <span className='mr-1 text-sm'>$</span>
                                <input
                                    placeholder='Other'
                                    className='hide-input-background text-sm input-color outline-none w-full p-1'
                                    type="number"
                                    step="0.1"
                                    name="other_charges"
                                    defaultValue={props.value.other_charges !== "" ? props.value.other_charges : ""}
                                    onChange={updateValue} />
                            </div>
                        </div>
                    </div>
                    <div className='w-full'>

                        <div className='mb-4'>
                            <p className={`text-sm mb-1 ${invalid.includes("municipal_tax") ? "text-[red]" : ""}`}>Municipal Tax</p>
                            <div className='flex flex-nowrap items-center'>
                                <span className='mr-1 text-sm'>$</span>
                                <input
                                    placeholder='Municipal Tax'
                                    className='hide-input-background text-sm input-color outline-none w-full p-1'
                                    type="number"
                                    step="0.1"
                                    name="municipal_tax"
                                    defaultValue={props.value.municipal_tax !== "" ? props.value.municipal_tax : ""}
                                    onChange={updateValue} />
                            </div>
                        </div>
                        <div className='mb-4'>
                            <p className={`text-sm mb-1 ${invalid.includes("pst_cost") ? "text-[red]" : ""}`}>PST</p>
                            <div className='flex flex-nowrap items-center'>
                                <span className='mr-1 text-sm'>$</span>
                                <input
                                    placeholder='PST'
                                    className='hide-input-background text-sm input-color outline-none w-full p-1'
                                    type="number"
                                    step="0.1"
                                    name="pst_cost"
                                    defaultValue={props.value.pst_cost !== "" ? props.value.pst_cost : ""}
                                    onChange={updateValue} />
                            </div>
                        </div>
                    </div>
                    <div className='w-full'>
                        <div className='mb-4'>
                            <p className={`text-sm mb-1 ${invalid.includes("gst_cost") ? "text-[red]" : ""}`}>GST</p>
                            <div className='flex flex-nowrap items-center'>
                                <span className='mr-1 text-sm'>$</span>
                                <input
                                    placeholder='GST'
                                    className='hide-input-background text-sm input-color outline-none w-full p-1'
                                    type="number"
                                    step="0.1"
                                    name="gst_cost"
                                    defaultValue={props.value.gst_cost !== "" ? props.value.gst_cost : ""}
                                    onChange={updateValue} />
                            </div>
                        </div>
                        <div className='mb-4'>
                            <p className="text-sm mb-1 font-bold">Total</p>
                            <div className='flex flex-nowrap items-center'>
                                <span className='mr-1 text-sm'>$</span>
                                <input
                                    placeholder='Total'
                                    className='hide-input-background text-sm input-color outline-none w-full p-1 font-bold'
                                    type="number"
                                    step="0.1"
                                    name="total"
                                    disabled
                                    value={props.value && totalList.reduce((t, k) => t + (parseFloat(props.value[k]) || 0), 0)} />
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
        </div>
    )
}

export default UtilityBillLineUpload
